module.exports = __webpack_public_path__ + "static/img/privilege-bg02.4c22026.png";